// this is taken from the "zipcelx"
// https://github.com/egeriis/zipcelx
// -- manually unpacked to ensure successful build --

import escape from "lodash/escape";

import JSZip from 'jszip';
import FileSaver from "file-saver";

// const CELL_TYPE_STRING = "string";
// const CELL_TYPE_NUMBER = "number";
const validTypes = ["string", "number"];
const MISSING_KEY_FILENAME = "Zipclex config missing property filename";
const INVALID_TYPE_FILENAME = "Zipclex filename can only be of type string";
const INVALID_TYPE_SHEET = "Zipcelx sheet data is not of type array";
const INVALID_TYPE_SHEET_DATA = "Zipclex sheet data childs is not of type array";
const WARNING_INVALID_TYPE = 'Invalid type supplied in cell config, falling back to "string"';
const childValidator = e => e.every(i => Array.isArray(i));

const validator = e => {
  if (e.filename) {
    if (typeof e.filename !== "string") {
      console.error(INVALID_TYPE_FILENAME);
      return false;
    }
    if (Array.isArray(e.sheet.data)) {
      if (childValidator(e.sheet.data)) return true;
      console.error(INVALID_TYPE_SHEET_DATA);
      return false;
    }
    console.error(INVALID_TYPE_SHEET);
    return false;
  }
  console.error(MISSING_KEY_FILENAME);
  return false;
}


const generateColumnLetter = e => {
  if (typeof e === "number") return "";
  const o = Math.floor(e / 26);
  const t = String.fromCharCode(97 + e % 26).toUpperCase();
  return (o === 0) ? t : generateColumnLetter(o - 1) + t;
};
const generatorCellNumber = (e, o) => `${generateColumnLetter(e)}${o}`;
const generatorStringCell = (e, o, t) => `<c r="${generatorCellNumber(e, t)}" t="inlineStr"><is><t>${escape(o)}</t></is></c>`;
const generatorNumberCell = (e, o, t) => `<c r="${generatorCellNumber(e, t)}"><v>${o}</v></c>`;
const formatCell = (e, o, t) => {
  if (validTypes.indexOf(e.type) === -1) {
    console.warn(WARNING_INVALID_TYPE);
    e.type = "string";
  }
  // validTypes.indexOf(e.type) === -1 && (console.warn(WARNING_INVALID_TYPE), e.type = "string"),
  return (e.type === "string")
    ? generatorStringCell(o, e.value, t)
    : generatorNumberCell(o, e.value, t);
};

const formatRow = (e, o) => {
  const t = o + 1;
  const s = e
    .map((i, p) => formatCell(i, p, t))
    .join("");
  return `<row r="${t}">${s}</row>`;
};
const  generatorRows = e => e.map((el, o) => formatRow(el, o)).join("");

const workbookXML = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main"><workbookPr/><sheets><sheet state="visible" name="Sheet1" sheetId="1" r:id="rId3"/></sheets><definedNames/><calcPr/></workbook>';
const workbookXMLRels = '<?xml version="1.0" ?>\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">\n<Relationship Id="rId3" Target="worksheets/sheet1.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"/>\n</Relationships>';
const rels = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\n<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>';
const contentTypes = '<?xml version="1.0" ?>\n<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">\n<Default ContentType="application/xml" Extension="xml"/>\n<Default ContentType="application/vnd.openxmlformats-package.relationships+xml" Extension="rels"/>\n<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml" PartName="/xl/worksheets/sheet1.xml"/>\n<Override ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml" PartName="/xl/workbook.xml"/>\n</Types>';
const templateSheet = '<?xml version="1.0" ?>\n<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:mc="http://schemas.openxmlformats.org/markup-compatibility/2006" xmlns:mv="urn:schemas-microsoft-com:mac:vml" xmlns:mx="http://schemas.microsoft.com/office/mac/excel/2008/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships" xmlns:x14="http://schemas.microsoft.com/office/spreadsheetml/2009/9/main" xmlns:x14ac="http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac" xmlns:xm="http://schemas.microsoft.com/office/excel/2006/main"><sheetData>{placeholder}</sheetData></worksheet>';

const generateXMLWorksheet = e => {
  const o = generatorRows(e);
  return templateSheet.replace("{placeholder}", o)
};

const zipcelx = e => {
  if (!validator(e)) throw new Error("Validation failed.");
  const o = new JSZip;
  const t = o.folder("xl");
  t.file("workbook.xml", workbookXML);
  t.file("_rels/workbook.xml.rels", workbookXMLRels);
  o.file("_rels/.rels", rels);
  o.file("[Content_Types].xml", contentTypes);
  const s = generateXMLWorksheet(e.sheet.data);
  t.file("worksheets/sheet1.xml", s);
  return  o.generateAsync({ type: "blob", mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" })
    .then(p => { FileSaver.saveAs(p, `${e.filename}.xlsx`) })
};

export default zipcelx;

export { generateXMLWorksheet };



// WEBPACK FOOTER //
// ./src/components/manage/seatingchart/util/makeXSLX.js